import { render, staticRenderFns } from "./Certificat_comments.vue?vue&type=template&id=83965f0c&"
import script from "./Certificat_comments.vue?vue&type=script&lang=ts&"
export * from "./Certificat_comments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports